import './CompanyName.scss';

export const CompanyName = ({company}) => {
    const initial = `${company[0]}`;

    return (
        <div className={"company-name"}>
            <div className={"company-name_container"}>
                <div className={"company-name_container_avatar"}>
                    {initial}
                </div>
                <div className={"company-name_container_title"}>
                    {company}
                </div>
            </div>
        </div>
    )
}